import dayjs, { Dayjs } from 'dayjs';

// Checks if the date is in the future
export const disableFutureDates = (current: Dayjs) => current && current > dayjs().endOf('day');
